import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import InputField from 'forms/shared/fields/input'
import TextAreaField from 'forms/shared/fields/text-area'
import DropdownField from 'forms/shared/fields/select-dropdown'
import DatePickerDropdownField from 'forms/shared/fields/date-picker-dropdown'
import TimePickerDropdownField from 'forms/shared/fields/time-picker-dropdown'
import ContactField from 'forms/shared/fields/contact'
import { FORM_ERROR_CLASS } from 'constants/css-style'

const Fields = ({ spaceOptions }) => (
  <div className="m-3">
    <Field
      type="dropdown"
      name="space"
      options={spaceOptions}
      placeholder={'Select a Space..'}
      groupClassName="my-4"
      inputClassName="py-2 regular text-xs"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName={FORM_ERROR_CLASS}
      component={DropdownField}
    />
    <div className="flex my-4">
      <Field
        type="dropdown"
        name="schedule"
        placeholder="Select a date"
        showIcon
        pickerClassName="w-12/7"
        boxClassName="w-11/12 border rounded-lg p-3 cursor-pointer"
        showText={false}
        placeholderClassName="pl-2 text-sm w-full text-primary-lightgray"
        groupClassName="w-7/12"
        inputClassName="pl-1 regular text-sm w-full"
        inputGroupClassName=""
        inputErrorClassName="border-action-danger"
        errorClassName={FORM_ERROR_CLASS}
        component={DatePickerDropdownField}
      />
      <Field
        type="dropdown"
        name="time"
        groupClassName="w-5/12 flex flex-col items-end"
        showText={false}
        showIcon
        pickerClassName="w-12/5"
        placeholderClassName="pl-2 text-sm w-full text-primary-lightgray"
        inputClassName="pl-1 regular text-sm w-full"
        inputGroupClassName=""
        inputErrorClassName="border-action-danger"
        errorClassName={`${FORM_ERROR_CLASS} w-full`}
        component={TimePickerDropdownField}
      />
    </div>
    <Field
      type="text"
      name="firstName"
      groupClassName="my-4"
      placeHolder="First Name"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName={FORM_ERROR_CLASS}
      component={InputField}
    />
    <Field
      type="text"
      name="lastName"
      groupClassName="my-4"
      placeHolder="Last Name"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName={FORM_ERROR_CLASS}
      component={InputField}
    />
    <Field
      type="text"
      name="email"
      groupClassName="my-4"
      placeHolder="Email"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName={FORM_ERROR_CLASS}
      component={InputField}
    />
    <Field
      type="tel"
      name="phone"
      groupClassName="my-4"
      placeHolder="Contact Number"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName={FORM_ERROR_CLASS}
      component={ContactField}
    />
    <Field
      type="text"
      name="message"
      rows={5}
      groupClassName="my-4"
      placeholder="Your message goes directly to the Space Operators - make sure to include as many details as possible!"
      inputClassName="block border text-xs border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName={FORM_ERROR_CLASS}
      component={TextAreaField}
    />
    <p className="text-xs text-center px-2">
      Create a password to join FlySpaces network and send your request directly to the space.
    </p>
    <Field
      type="password"
      name="password"
      groupClassName="my-4"
      placeHolder="Password"
      inputClassName="block border text-sm border-grey-light w-full p-3 rounded-lg"
      inputGroupClassName=""
      inputErrorClassName="border-action-danger"
      errorClassName={FORM_ERROR_CLASS}
      component={InputField}
    />
  </div>
)

Fields.propTypes = {
  spaceOptions: PropTypes.array,
}

export default Fields
